import React from "react";
import MUIDialogContent from "@mui/material/DialogContent";
import { getClassName } from "@sscs/utils";
import { RequiredFieldsContext, useRequiredFieldsRegistry, } from "../Form/requiredFields";
import styles from "./dialog.module.scss";
import Legend from "./DialogLegend";
const Body = ({ bleed = false, className, children, }) => {
    const { hasRequiredFields, registry } = useRequiredFieldsRegistry();
    return (React.createElement(MUIDialogContent, { className: getClassName(styles.body, className, {
            [styles.bleed]: bleed,
        }) },
        React.createElement(RequiredFieldsContext.Provider, { value: registry },
            children,
            hasRequiredFields && React.createElement(Legend, null))));
};
export default Body;
//# sourceMappingURL=DialogBody.js.map